<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <excuse-create-or-update v-model="excuse" :types="types"></excuse-create-or-update>
            <template #modal-footer>
                <v-executer v-if="excuse.Id" :loading="deleting" :disabled="saving" variant="danger" :action="deleteExcuse" text="Sil"></v-executer>
                <v-executer :loading="saving" :disabled="deleting" :editing="editing" :action="createOrUpdate"></v-executer>
            </template>
        </b-modal>


        <b-overlay :show="getting" opacity="0.2">
            <div class="p-75">
                <div class="row">
                    <div class="col-md-auto mb-1 mb-md-0">
                        <button class="btn btn-primary btn-icon rounded-circle text-nowrap" v-on:click="createNew">
                            <feather-icon icon="PlusIcon" size="16"></feather-icon>
                        </button>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0">
                        <v-select-list :options="types" :disabled="(types || []).length == 0" label="Name" v-model="type" placeholder="Tümü"></v-select-list>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0">
                        <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Şube"></v-select-list>
                    </div>
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control" v-model="month">
                            <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                        </select>
                    </div>
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control" v-model="year">
                            <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                        </select>
                    </div>
                    <div class="col-md-auto mb-1 mb-md-0">
                        <button class="btn btn-success btn-block" v-on:click="getData">
                            Sorgula
                        </button>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0 ml-auto">             
                        <b-input-group class="input-group-merge">
                            <template #prepend>
                                <b-input-group-text >
                                    <feather-icon icon="SearchIcon"></feather-icon>
                                </b-input-group-text>
                            </template>
                            <b-form-input placeholder="Ara..." v-model="searchValue" v-on:input="startTimer"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-hover table-sm bordered-header">
                    <thead>
                        <tr>
                            <th rowspan="2" class="align-middle column-sticky">Personel</th>
                            <th rowspan="2" class="align-middle text-nowrap">Sicil Numarası</th>
                            <th :colspan="daysOfMonth.length" class="w-100">{{ months.find(m=>m.index == showingMonth).name }} {{ showingYear }}</th>
                        </tr>
                        <tr>
                            <th class="text-center" v-for="d in daysOfMonth">{{ convertToDay(d) }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ex,i) in excuses" :key="i">
                            <td class="text-nowrap align-middle border-right column-sticky">{{ ex.EmployeeFullName }}</td>
                            <td class="text-nowrap align-middle border-right">{{ ex.RegistirationNumber }}</td>
                            <template v-for="(e,ii) in ex.Excuses">
                                <template v-if="e.DaySpecification">
                                    <td :colspan="e.Duration ? Math.ceil(e.Duration) : 0" :class="[$safe(e,'DaySpecification.Color'),'align-middle excuse-icon']" v-on:click="edit(e)">
                                        <div class="d-flex text-nowrap align-items-center">
                                            <span class="material-icons-outlined d-block mr-25">{{$safe(e,'DaySpecification.Icon')}}</span>
                                            {{ $safe(e,'DaySpecification.Name') }}
                                        </div>
                                        <div class="text-nowrap mt-25 font-weight-bolder">{{ e.Excuse.StartDateTimeStr == e.Excuse.EndDateTimeStr ? e.Excuse.StartDateTimeStr : [e.Excuse.StartDateTimeStr,e.Excuse.EndDateTimeStr].join(' - ') }}</div>
                                    </td>
                                </template>
                                <template v-else>
                                    <td></td>
                                </template>
                            </template>
                        </tr>
                        <tr v-if="(excuses || []).length == 0">
                            <td colspan="100" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="(excuses || []).length" class="mx-75 mb-1">
                <div class="row justify-content-md-between justify-content-center">
                    <div class="col-auto mb-1 mb-md-0">
                        <div class="d-flex align-items-center text-nowrap">
                            Toplam {{(count || 0)}} kayıt arasından
                            <select class="form-control form-control-sm mx-50 per-page-select" v-model="perPage">
                                <option v-for="pp in perPages" :key="pp" :value="pp">{{pp}}</option>
                            </select>
                            gösteriliyor.
                        </div>
                    </div>
                    <div class="col-auto mb-1 mb-md-0">
                        <b-pagination class="mb-0" v-model="page" :total-rows="((count || 0))" :per-page="perPage"></b-pagination>
                    </div>
                </div>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import { BCard, BFormCheckbox, BFormCheckboxGroup, BOverlay, BPagination, BInputGroup, BInputGroupText,BFormInput } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import moment from 'moment'
import ExcuseFilter from './components/ExcuseFilter.vue'
import ExcuseCreateOrUpdate from './components/ExcuseCreateOrUpdate.vue'
import Additional from '@/utilities/additional'
import CompanyApi from '@/api/company'

export default {
    components:{
        BCard,
        BFormCheckbox,
        BFormCheckboxGroup,
        ExcuseFilter,
        BOverlay,
        BPagination,
        BInputGroup,
        BInputGroupText,
        BFormInput,
        ExcuseCreateOrUpdate
    },
    mounted(){
        this.getTypes()
        this.getData()
        this.getBranches()
    },
    data(){
        return {
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            deleting:false,
            saving:false,
            editing:false,
            perPages:[10,20,30,40,50,100],
            perPage:10,
            page:1,
            year:null,
            month:null,
            years:[],
            daysOfMonth:[],
            types:[],
            getting:true,
            excuses:[],
            count:0,
            type:null,
            searchOnTableTimer:null,
            searchValue:"",
            excuse:{
                Id:null,
                EmployeeId:null,
                ExcuseTypeId:null,
                RequestDate:null,
                StartDateTime:null,
                EndDateTime:null,
                Description:null,
                Approved:null,
                Document:null,
                JobStartDateTime:null,
                GroupKey:null
            },
            branches:[],
            branch:null
        }
    },
    created(){
        this.getCurrentYear()
        this.configureYears()
        this.getCurrentMonth()
        this.configureDaysOfMonth(Date.now())
    },
    watch:{
        "page"(oldV,newV){
            if(oldV && newV && oldV != newV){
                this.getData()
            }
        },
        "perPage"(oldV,newV){
            if(oldV && newV && oldV != newV){
                this.getData()
            }
        }
    },
    methods:{
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1980
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
        configureDaysOfMonth(date){
            this.daysOfMonth = []
            Array.from(Array(moment(date).daysInMonth()).keys()).forEach((d,index)=>{
                let _date = moment(date).startOf("month").add(d,'days')
                let _dateForName = _date.format('DD.MM.YYYY')
                this.daysOfMonth.push(_dateForName)
            })
        },
        getCurrentYear(){
            this.year = moment().format('YYYY')
            this.showingYear = this.year
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
                this.branches.unshift({Name:"TÜMÜ",Id:null})
            })
        },
        getCurrentMonth(){
            let current = moment().month() + 1
            this.month = this.months.find(m=>m.index == current)?.index || 0
            this.showingMonth = this.month
        },
        onTableRefresh(){
            let date = moment(this.year+'-'+this.month,'YYYY-MM')
            this.configureDaysOfMonth(date)
        },
        filter(filter){
            this.filterData = filter
            this.$refs.table.refresh()
        },
        getTypes(){
            EmployeeOperationsApi.ExcuseType.List().then(res=>{
                this.types = res.data.Data
            })
        },
        startTimer(){
            if(this.searchValue != null){
                const search = () => {
                    clearTimeout(this.searchOnTableTimer)
                    this.searchOnTableTimer = setTimeout(()=>this.getData(),500)
                }
                clearTimeout(this.searchOnTableTimer)
                this.searchOnTableTimer = setTimeout(()=>{ search.call(this) },500)
            }
        },
        getData(){
            this.getting = true
            EmployeeOperationsApi.Excuse.GetAllTable({
                Month:this.month,
                Year:this.year,
                EmployeeExcuseTypeId: this.type ? this.type.Id : null,
                BranchId:this.branch?.Id || null,
                PaginationRequest:{
                    IsAscending:true,
                    OrderColumnName:'FullName',
                    QueryParam:this.searchValue,
                    Skip:this.page,
                    Take:this.perPage
                }
            }).then(res=> {
                this.excuses = res.data.Data.Data || []
                this.count = res.data.Data.TotalCount || 0
                let date = moment(this.year+'-'+this.month,'YYYY-MM')
                this.configureDaysOfMonth(date)
                this.showingMonth = this.month
                this.showingYear = this.year
                this.getting = false
            }).catch(err => {
                this.getting = false
            })
        },
        convertToDay(d){
            return moment(d,'DD.MM.YYYY').format('DD')
        },
        clearForm(){
            this.editing = false
            this.excuse.Id = null
            this.excuse.EmployeeId = null
            this.excuse.ExcuseTypeId = null
            this.excuse.RequestDate = null
            this.excuse.StartDateTime = null
            this.excuse.EndDateTime = null
            this.excuse.Description = null
            this.excuse.Approved = null
            this.excuse.Document = null
            this.excuse.JobStartDateTime = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.excuse.Id = item.Excuse.Id
            this.excuse.EmployeeId = item.Excuse.Employee?.Id || null
            this.excuse.ExcuseTypeId = item.Excuse.EmployeeExcuseType?.Id
            this.excuse.RequestDate = item.Excuse.RequestDate ? moment(item.Excuse.RequestDate,'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm') : null
            this.excuse.StartDateTime = item.Excuse.StartDateTime ? moment(item.Excuse.StartDateTime,'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm') : null
            this.excuse.EndDateTime = item.Excuse.EndDateTime ? moment(item.Excuse.EndDateTime,'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm') : null
            this.excuse.Description = item.Excuse.Description
            this.excuse.Approved = item.Excuse.Approved
            this.excuse.Document = item.Excuse.Document
            this.excuse.JobStartDateTime = item.Excuse.JobStartDateTime ? moment(item.Excuse.JobStartDateTime,'YYYY-MM-DDThh:mm:ss').format('YYYY-MM-DD HH:mm') : null
            this.$showModal('create-or-update')
        },
        async createOrUpdate(){
            this.saving = true
            let formData = await Additional.ToFormData(this.excuse,['Document'])
            EmployeeOperationsApi.Excuse.CreateOrUpdate(formData).then(res=>{
                this.$result(res)
                this.saving = false
                if(res.data.Success){
                    this.getData()
                    this.$hideModal('create-or-update')
                }
            }).catch(err=>{
                this.saving = false
                this.$result(null,err)
            })
        },
        deleteExcuse(){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem seçilen izni silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    this.deleting = true
                    EmployeeOperationsApi.Excuse.Delete(this.excuse.Id).then(res=>{
                        this.deleting = false
                        this.$result(res)
                        if(res.data.Success) {
                            this.getData()
                            this.$hideModal('create-or-update')
                        }
                    }).catch(err=>{
                        this.deleting = false
                        this.$result(null,err)
                    })
                }
            })
        },
    },
}
</script>

<style>
.excuse-icon{
    font-size: 0.75rem;
}

.excuse-icon span{
    font-size: 1rem;
}

.column-sticky{
    position: sticky;
    left: 0px;
    box-shadow: inset -1px 0px 0px 0px #d4d2de;
    z-index: 1;
}
.dark-layout .column-sticky{
    box-shadow: inset -1px 0px 0px 0px rgb(75, 82, 103) !important;
}

.column-sticky:not(th){
    background-color: white;
}

.dark-layout .column-sticky:not(th){
    background-color: #283046 !important;
}
</style>